module.exports = __webpack_public_path__ + "74f92d5c4d1e02f0d253b5515440db6e.svg";